import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { AuthRefreshTokenInterface } from './definitions/auth-refresh-token.interface';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';

@Injectable()
export class AuthRefreshTokenService {
  constructor(private client: HttpClient, private configService: ConfigService) {}

  public refreshToken(refreshToken: string): Observable<AuthRefreshTokenInterface> {
    const url = `${this.configService.config.rest.apiV2Url}/auth/refresh-token`;

    return this.client.post<AuthRefreshTokenInterface>(url, { token: refreshToken }).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
